// ==============================|| LOGO SVG ||============================== //

const Logo = () => (
  <span
    style={{
      fontWeight: 'bold',
      fontSize: '18px'
    }}
  >
    CulturePulse API
  </span>
);

export default Logo;
